// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Cookies from 'js-cookie'
import zenscroll from 'zenscroll'

// Internal Dependencies:
import Loading from 'components/Loading/Loading'
import DataTable from 'components/DataTable/DataTable'
import Text from 'components/Form/Text'
import Select from 'components/Form/Select'
import IconSearch from 'components/svg/search.svg'

// Redux:
import * as reduxUser from 'actions/user'

class Contacts extends React.Component {
	constructor() {
		super()

		const perPage = Cookies.get( 'contacts_per_page' ) || 100

		this.state = {
			currentPage: 1,
			perPage,
			search: ''
		}
		this.contactsRef = React.createRef()
	}

	componentDidMount() {
		window.scrollTo( 0, 0 )

		this.getResults()
	}

	componentDidUpdate( prevProps ) {
		const { accountData, dispatch } = this.props

		if ( accountData && accountData.is_staff && ! prevProps.accountData ) {
			this.getResults()
		}
	}

	getResults = () => {
		const { accountData, dispatch } = this.props
		const { currentPage, perPage, search } = this.state

		if ( accountData && accountData.is_staff ) {
			dispatch( reduxUser.getContactsData( currentPage, perPage, search ) )
		}
	}

	handleChangePerPage = ( e ) => {
		const value = parseInt( e.target.value, 10 )

		Cookies.set( 'contacts_per_page', value )

		this.setState( {
			perPage: value
		}, () => {
			this.getResults()
		} )
	}

	handleClickPage = ( e ) => {
		this.setState( {
			currentPage: parseInt( e.currentTarget.getAttribute( 'data-page' ), 10 )
		}, () => {
			this.getResults()
		} )

		zenscroll.to( this.contactsRef.current, 400 )
	}

	handleChangeSearch = ( id, value ) => {
		this.setState( {
			search: value
		} )
	}

	handleApplyFilters = ( e ) => {
		e.preventDefault()

		this.getResults()
	}

	renderSelectedRowInner = ( key, item ) => {
		return (
			<div className="-selected-inner" key={ key }>
				<div className="-selected-inner-content">
					{ item.phone &&
						<div className="-item">
							<div className="-key">Phone</div>
							<div className="-value">{ item.phone }</div>
						</div>
					}

					{ item.mobile &&
						<div className="-item">
							<div className="-key">Mobile</div>
							<div className="-value">{ item.mobile }</div>
						</div>
					}

					{ item.bed_name &&
						<div className="-item">
							<div className="-key">Bed Name</div>
							<div className="-value">{ item.bed_name }</div>
						</div>
					}

					{ item.state &&
						<div className="-item">
							<div className="-key">State</div>
							<div className="-value">{ item.state }</div>
						</div>
					}

					{ item.hotel_group &&
						<div className="-item">
							<div className="-key">Hotel Group</div>
							<div className="-value">{ item.hotel_group }</div>
						</div>
					}

					{ item.site_address &&
						<div className="-item">
							<div className="-key">Site Address</div>
							<div className="-value">{ item.site_address }</div>
						</div>
					}

					{ item.billing_address &&
						<div className="-item">
							<div className="-key">Billing Address</div>
							<div className="-value">{ item.billing_address }</div>
						</div>
					}

					{ item.notes &&
						<div className="-item">
							<div className="-key">Notes</div>
							<div className="-value">{ item.notes }</div>
						</div>
					}
				</div>
			</div>
		)
	}

	renderPagination = () => {
		const { contactsData } = this.props
		const { page, max_pages } = contactsData
		const { currentPage } = this.state

		if ( max_pages <= 1 ) {
			return null
		}

		const markup = [ ...Array( max_pages ) ].map( ( e, i ) => {
			i++

			if (
				i > 3 && // Show first 3.
				i <= ( max_pages - 3 ) && // Show last 3.
				i != ( max_pages / 2 ) && // Show middle.
				i != currentPage && // Show this page.
				i != currentPage + 1 && // Show next page.
				i != currentPage - 1 // Show previous page.
			) {
				return null
			}

			var className = currentPage == i ? '-page is-active' : '-page'

			return (
				<button className={ className } onClick={ this.handleClickPage } data-page={ i } key={ i }>
					{ i }
				</button>
			)
		} )

		const prevClass = currentPage > 1 ? '-prev' : '-prev is-disabled'
		const nextClass = currentPage < max_pages ? '-next' : '-next is-disabled'

		return (
			<div className="-pagination">
				<button className={ prevClass } onClick={ this.handleClickPage } data-page={ currentPage - 1 }></button>

				{ markup }

				<button className={ nextClass } onClick={ this.handleClickPage } data-page={ currentPage + 1 }></button>
			</div>
		)
	}

	render() {
		const { accountData, contactsData } = this.props
		const { perPage, currentPage } = this.state

		if ( ! contactsData || ! contactsData.items ) {
			return (
				<div className="page-plain">
					<div className="-inner">
						<div className="-content">
							<Loading />
						</div>
					</div>
				</div>
			)
		}

		return (
			<div className="page-plain page-data-table">
				<div className="-inner">
					<h2>Contacts</h2>

					<div className="data-table-wrap" ref={ this.contactsRef }>
						<form className="-filters" onSubmit={ this.handleApplyFilters }>
							<div className="-cell -search-wrap">
								<Text
									id="search"
									label="Search"
									onChange={ this.handleChangeSearch }
									uncontrolled={ true }
								/>

								<button className="-search" type="submit">
									<IconSearch />
								</button>
							</div>
						</form>

						<DataTable
							sortedColumn="created"
							sortedColumnKey="created"
							sortDirection="desc"
							data={ contactsData.items }
							renderSelectedRowInner={ this.renderSelectedRowInner }
							columns={ [
								{
									title: 'Date of purchase',
									data_key: 'date_of_purchase',
									data_type: 'text',
									can_sort: false,
									can_sort: true,
									sort_key: 'date_of_purchase',
									flex: 1
								},
								{
									title: 'Serial Number',
									data_key: 'serial_number',
									data_type: 'text',
									can_sort: false,
									flex: 1
								},
								{
									title: 'Email',
									data_key: 'email',
									data_type: 'text',
									can_sort: false,
									flex: 1
								},
								{
									title: 'Name',
									data_key: 'first_name',
									data_key_2: 'last_name',
									data_type: 'text',
									can_sort: false,
									flex: 1
								},
								{
									title: 'Retailer',
									data_key: 'retailer',
									data_type: 'text',
									can_sort: false,
									flex: 1
								}
							] }
						/>

						<div className="data-nav">
							<div className="-per-page">
								<div className="form-select-dropdown">
									<select onChange={ this.handleChangePerPage } value={ perPage }>
										<option value="50">50</option>
										<option value="100">100</option>
										<option value="200">200</option>
									</select>
								</div>
							</div>

							{ this.renderPagination() }
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		accountData: state.user.accountData,
		contactsData: state.user.contactsData
	}
}

export default connect( mapStateToProps )( Contacts )
